module.exports = __webpack_public_path__ + "static/media/9x12no1.f9393185.jpg";